import { createSlice } from '@reduxjs/toolkit'
import { 
  createUpdateWard, 
  fetchWardList, 
  deleteWard,
  toggleActivation, 
  getWardByWardId  } from '../actions/wardsAction'

export const wards = createSlice({
  name: 'wards',
  initialState: {
    wards: null,
    error: null,
    sortBy: null,
    isLoader: false,
    isRecordAdded: false,
    isRecordUpdated: false,
    isRecordLoaded:false,
    isManageWardPage:false,
  },
  reducers: {
    wardReset: state => {
      // state.wards= null;
      state.error = null;
    },

   
    resetPopup: state => {
      state.isLoader= false;
      state.isRecordAdded= false;
      state.isRecordUpdated= false;
      state.error=null;
    },
    setManageWardPage: state => {
      state.isManageWardPage = true;
    },
    resetManageWardPage: state => {
      state.isManageWardPage = false;
    }
  },
  extraReducers: {
    [fetchWardList.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },
    [fetchWardList.fulfilled]: (state, {payload}) => {
      state.error=null;
      return {
        ...state,
        ...payload?.data,
        isLoader: false
      }
    },
    [fetchWardList.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
    },
    [createUpdateWard.pending]: (state, payload) => {
      state.error=null;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [createUpdateWard.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isRecordAdded=true;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [createUpdateWard.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordAdded=false;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [deleteWard.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [deleteWard.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [deleteWard.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },
    [toggleActivation.pending]: (state, payload) => {
      state.error=null;
      state.isRecordUpdated= false;
      state.isLoader= true;
    },
    [toggleActivation.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordUpdated= true;
      state.isLoader= false;
    },
    [toggleActivation.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordUpdated= false;
      state.isLoader= false;
    },

    [getWardByWardId.pending]: (state, payload) => {
      state.error=null;
      state.isRecordLoaded= false;
      state.isLoader= true; 
    },
    [getWardByWardId.fulfilled]: (state, {payload}) => {   
      state.error=null;
      state.isRecordLoaded= true
      state.isLoader= false;
    },
    [getWardByWardId.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isRecordLoaded= false;
      state.isLoader= false;
    },
    
  }
})

// Action creators are generated for each case reducer function
export const { wardReset, resetPopup } = wards.actions

export default wards.reducer